import { render, staticRenderFns } from "./BaseTooltipDropdown.vue?vue&type=template&id=62dd1b12&scoped=true&lang=pug&"
import script from "./BaseTooltipDropdown.vue?vue&type=script&lang=js&"
export * from "./BaseTooltipDropdown.vue?vue&type=script&lang=js&"
import style0 from "./BaseTooltipDropdown.vue?vue&type=style&index=0&id=62dd1b12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dd1b12",
  null
  
)

export default component.exports